import { ChangeDetectionStrategy, Component, Signal, computed, input } from '@angular/core';
import {
    CeButtonComponent,
    CeParameterListImports,
    CePillComponent,
} from '@kempower-nx-workspace/shared/kp-design-system';
import { RouterLink } from '@angular/router';
import { EnrichedFrontendNotification, GetNotificationEmailSentTimestampResponse } from '../../data-access/notification-data/notification-data.service';

@Component({
    selector: 'ce-notification-vehicle-telematics-content',
    imports: [
        CeButtonComponent,
        CeParameterListImports,
        CePillComponent,
        RouterLink,
    ],
    templateUrl: './notification-vehicle-telematics-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationVehicleTelematicsContentComponent {
    notification = input.required<EnrichedFrontendNotification>();
    emailTimestamp = input<GetNotificationEmailSentTimestampResponse | undefined>();
    detailsUrl = input.required<string>();
    linkLabel = input.required<string>();

    hasMultipleEvents: Signal<boolean> = computed(() => this.notification().events.length > 1);

    showResolutionReason: Signal<boolean> = computed(() => {
        return (
            this.notification().events.length === 1 &&
            !!this.notification().events[0]?.resolvedTimestamp &&
            !!this.notification().events[0]?.resolutionReason
        );
    });
}
